import { useFormContext } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input, InputProps } from '../ui/input';

import { cn } from '../../lib/utils';

interface IProps extends InputProps {
  name: string;
  label?: string;
  required?: boolean;
}

export default function InputField({
  name,
  label,
  required,
  disabled,
  inputClassName,
  ...inputProps
}: IProps) {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem className="w-full">
          {label && (
            <FormLabel
              className={cn(
                'transition-all text-body-base-regular',
                fieldState.error && 'text-error',
                !fieldState.error && field.value && 'text-muted-foreground'
              )}
            >
              {required && (
                <span className="text-red-500 dark:text-red-900">*</span>
              )}
            </FormLabel>
          )}
          <FormControl>
            <Input
              {...field}
              {...inputProps}
              disabled={disabled}
              inputClassName={inputClassName}
              className={cn(
                'shadow-none bg-fill-base rounded-xl',
                fieldState.error
                  ? 'border-2 border-red-500'
                  : field.value
                    ? 'border border-success'
                    : 'border border-border placeholder:text-body-base-regular',
                inputProps.className
              )}
            />
          </FormControl>
          <FormMessage className="text-red-500 " />
        </FormItem>
      )}
    />
  );
}
